module.exports = __webpack_public_path__ + "img/download.615ce09b.svg";